import { Link } from 'react-router-dom';
import type { MovieListItem } from '../api/library';

interface Props {
  item: MovieListItem;
}

export function MediaCard({ item }: Props) {
  const isReady = item.status === 'ready';
  const showStatusBadge = item.status !== 'ready';

  return (
    <Link
      to={`/movies/${item.id}`}
      className="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-2xl"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden rounded-2xl bg-surface-2 shadow-sm">
        {item.posterUrl ? (
          <img
            src={item.posterUrl}
            alt={item.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center text-text-secondary text-sm">
            No poster
          </div>
        )}
        {showStatusBadge && (
          <div className="absolute left-2 top-2 rounded-full bg-base-100/90 px-2 py-0.5 text-xs font-medium text-text-primary shadow-sm">
            {labelFor(item.status)}
          </div>
        )}
        {!isReady && (
          <div className="absolute inset-0 bg-base-100/30 backdrop-blur-[1px]" aria-hidden />
        )}
      </div>
      <div className="mt-2 px-1">
        <div className="truncate text-sm font-medium">{item.title}</div>
        {item.year && <div className="text-xs text-text-secondary">{item.year}</div>}
      </div>
    </Link>
  );
}

function labelFor(status: MovieListItem['status']): string {
  switch (status) {
    case 'awaiting_upload': return 'Uploading…';
    case 'queued': return 'Queued';
    case 'transcoding': return 'Transcoding…';
    case 'failed': return 'Failed';
    default: return status;
  }
}
